import { Box, Grid, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import SideDrawer from "../../components/SideDrawer";
import TweetCard from "../../components/TweetCard";
import { StyledArrowButton } from "../../components/SmallComponents/AppComponents";
import { AppContext, serverUrl, twitterPostLink } from "../../utils";
import axios from "axios";
import PointsCalculator from "../../components/PointCalculate";

function Feeds() {
  const { userDatabaseId } = useContext(AppContext);
  const [userTweets, setUserTweets] = useState([]);
  const [pointsCallculatorOpen, setPointsCallculatorOpen] = useState(0);

  useEffect(() => {
    if (userDatabaseId) {
      (async () => {
        try {
          const { data: tweetData } = await axios.get(
            `${serverUrl}/userTweets/${userDatabaseId}`
          );
          setUserTweets(tweetData?.data);
        } catch (e) {
          console.log(e);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDatabaseId]);

  return (
    <SideDrawer>
      <PointsCalculator
        open={pointsCallculatorOpen}
        setOpen={setPointsCallculatorOpen}
      />
      <Typography
        variant="h1"
        sx={{
          fontFamily: "Saira Semi Condensed",
          fontWeight: 700,
          letterSpacing: "1px",
          fontSize: { xs: "30px", sm: "40px" },
          lineHeight: "50px",
          textAlign: { xs: "center", md: "left" },
          color: "#ffffff",
          textTransform: "uppercase",
        }}
      >
        BITGROK AI is a powerhouse layer-1 POA blockchain
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontFamily: "Montserrat",
          fontWeight: 400,
          fontSize: { xs: "16px", sm: "18px" },
          textAlign: { xs: "center", md: "left" },
          lineHeight: "24px",
          color: "#ffffff",
          textTransform: "uppercase",
          my: 3,
        }}
      >
        $BGAI is BITGROK AI blockchain native token that rewards interaction
        between our community members & non community members. By tweeting you
        are helping spread the word of $BGAI while in return getting rewarded in
        $BGAI for doing so.
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography
            variant="h3"
            sx={{
              fontFamily: "Saira Semi Condensed",
              fontWeight: 800,
              fontSize: { xs: "22px", sm: "24px" },
              lineHeight: "50px",
              letterSpacing: "1px",
              textAlign: { xs: "center", md: "left" },
              color: "#ffffff",
              textTransform: "uppercase",
            }}
          >
            Your Recent{" "}
            <span
              style={{
                color: "#8102FF",
              }}
            >
              Tweets
            </span>
          </Typography>
        </Grid>
        {userTweets?.length > 0 ? (
          userTweets?.slice(0, 2)?.map((tweet, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              key={index * Math.random() + 1 * Math.random()}
            >
              <TweetCard data={tweet} />
            </Grid>
          ))
        ) : (
          <Grid item xs={12} sm={12}>
            <Typography
              variant="h3"
              sx={{
                fontFamily: "Saira Semi Condensed",
                fontWeight: 500,
                fontSize: { xs: "16px" },
                lineHeight: "50px",
                textAlign: { xs: "center", md: "left" },
                color: "#ffffff",
                textTransform: "uppercase",
              }}
            >
              No tweets found
            </Typography>
          </Grid>
        )}

        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "start" },
            }}
          >
            <StyledArrowButton
              width="250px"
              onClick={() => setPointsCallculatorOpen(true)}
            >
              Calculate Points
            </StyledArrowButton>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "start" },
            }}
          >
            <StyledArrowButton
              // href="https://twitter.com/compose/post"
              href={twitterPostLink}
              target="_blank"
              width={{ xs: "250px", sm: "180px" }}
            >
              {" "}
              Post Tweet
            </StyledArrowButton>
          </Box>
        </Grid>
      </Grid>
    </SideDrawer>
  );
}

export default Feeds;
